import { render, staticRenderFns } from "./AdminWorkshopTasksEditScreen.vue?vue&type=template&id=33fabc78&scoped=true&"
import script from "./AdminWorkshopTasksEditScreen.vue?vue&type=script&lang=js&"
export * from "./AdminWorkshopTasksEditScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fabc78",
  null
  
)

export default component.exports